// extracted by css-extract-rspack-plugin
export default {"actionIcon":"t_Ge1","selectItem":"xfIPx"};